import { createSlice } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';

const initialState = {
	all: null,
};

const propertiesSlice = createSlice({
	name: 'properties',
	initialState,
	reducers: {
		setProperties: (state, action) => {
			if (action.payload) {
				state.all = action.payload.properties;
			}
		},
		resetProperties: (state) => {
			state.all = initialState.all;
		},
	},
});

export default propertiesSlice.reducer;
export const { setProperties, resetProperties } = propertiesSlice.actions;

export const selectAllProperties = (state) => state.properties.all;
export const selectPropertyById = (state, propertyId) => Object.values(state.properties.all ?? {})?.find((el) => el.id === propertyId) ?? null;
export const selectPropertiesByIds = (state, propertyIds) => {
	if (!propertyIds) {
		return null;
	}

	const properties = Object.values(state.properties.all)?.filter((property) => propertyIds.includes(property.id));

	return keyBy(properties, 'id');
};
